import {Image} from "../../types/admin";
import {ADMIN_LANG} from "../../settings";
import {Form, InputGroup} from "react-bootstrap";
import React from "react";
import MediaPreview from "./MediaPreview";

type Props = {
    defaultImage: Image | null
    setImage: (image: File | null) => void
    label?: string
    help_text?: string
    accept?: string
    required?: boolean
}

const ImageField = ({
                        defaultImage,
                        setImage,
                        label = ADMIN_LANG.image,
                        help_text = ADMIN_LANG.image_help,
                        accept = '',  // image/jpeg,image/png,image/jpg
                        required = false
                    }: Props) => {

    const handleImageAdd = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setImage(e.target.files[0]);
        }else{
            setImage(null);
        }
    }

    let elem;

    if (defaultImage) {
        elem = (
            <Form.Group className='pb-3'>
                <Form.Label>{label}</Form.Label>
                <MediaPreview
                    // Preview the thumbnail, not the original: admins upload 1920x1080 backgrounds.
                    src={defaultImage.thumbnail_url || defaultImage.url}
                    alt={defaultImage.name || label}
                    onAction={() => setImage(null)}
                />
            </Form.Group>
        );
    } else {
        elem = (
            <Form.Group className='pb-3' controlId={label}>
                <Form.Label>{label}</Form.Label>
                <InputGroup>
                    <Form.Control type='file' onChange={handleImageAdd} accept={accept} required={required}/>
                </InputGroup>
                <Form.Text className='help-text'
                           dangerouslySetInnerHTML={{__html: help_text}}></Form.Text>
            </Form.Group>
        );
    }

    return (
        <>
            {elem}
        </>
    )
}


export default ImageField;
